import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/faq.css";

const TERMSPage = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/"); // Navigate back to the home page
  };

  return (
    <div className="faq-container">
      <header className="faq-header">
        <button className="back-button" onClick={handleBackClick}>
          ← Back
        </button>
        <div className="logo-container">
          <a href="/">
            <img
              src="./eblogo_2.png"
              alt="ExpenseBot Logo"
              className="faq-logo"
            />
          </a>
        </div>
        <div className="faq-title-container">
          <h1 className="faq-title">Terms of Service</h1>
        </div>
      </header>

      <div className="faq-item">
        <p className="faq-question">1. Acceptance of Terms</p>
        <p className="faq-answer">
          By using ExpenseBot ("Service"), you agree to be bound by these terms.
          If you do not agree, you may not use the Service.
        </p>
      </div>

      {/* Adding Gmail section as new section 2 */}
      <div className="faq-item">
        <p className="faq-question">2. Gmail Integration</p>
        <p className="faq-answer">
          As part of our service, ExpenseBot can integrate with Gmail to
          automatically process expense-related emails. This integration is
          completely optional and permissions are only requested when you
          explicitly click on the "Process from Gmail" button. By using this
          feature, you grant ExpenseBot permission to:
          <ul>
            <li>Read emails you have specifically tagged with "ExpenseBot"</li>
            <li>Apply "Processed" labels to emails after processing</li>
            <li>Extract receipt data from email content and attachments</li>
          </ul>
          <br />
          <strong>Important Privacy Points:</strong>
          <ul>
            <li>
              Gmail access permissions are only requested when you explicitly
              opt-in by clicking the "Process from Gmail" button
            </li>
            <li>We only access emails explicitly tagged by you</li>
            <li>
              We never permanently store your email content on our servers
            </li>
            <li>
              All processed receipt data is stored in your own Google Drive
            </li>
            <li>
              We use the minimum necessary Gmail API scopes to provide our
              service
            </li>
          </ul>
          <br />
          Our use of Gmail data adheres to the Google API Services User Data
          Policy, including the Limited Use requirements.
        </p>
      </div>

      {/* Original section 2, now section 3 */}
      <div className="faq-item">
        <p className="faq-question">3. Use of the Service</p>
        <p className="faq-answer">
          You agree to use the Service only for lawful purposes and in a manner
          that does not infringe the rights of, or restrict or inhibit the use
          of the Service by any third party.
          <br />
          <br />
          <strong>Gmail Integration:</strong> When using the Gmail integration
          feature, you agree to only tag emails for processing that contain
          legitimate expense information and receipts. ExpenseBot will only scan
          emails specifically tagged for processing, not your entire inbox.
        </p>
      </div>

      {/* Original section 3, now section 4 */}
      <div className="faq-item">
        <p className="faq-question">4. User Content</p>
        <p className="faq-answer">
          You retain ownership of any data you upload to the Service. However,
          by uploading, you grant ExpenseBot the right to use, modify, and
          display your content to provide the Service.
          <br />
          <br />
          <strong>Email Content:</strong> You retain all ownership rights to
          your email content. We only process and display the content to provide
          our service to you. We never permanently store your email content on
          our servers.
        </p>
      </div>

      {/* Original section 4, now section 5 */}
      <div className="faq-item">
        <p className="faq-question">5. Termination</p>
        <p className="faq-answer">
          We reserve the right to suspend or terminate your access to the
          Service at any time, without notice, if you violate these terms.
          <br />
          <br />
          <strong>Gmail Access Termination:</strong> If you wish to terminate
          ExpenseBot's access to your Gmail account, you may do so at any time
          through your Google Account settings. Gmail integration is completely
          optional and we only process your emails when you explicitly request
          it by clicking the "Process from Gmail" button.
        </p>
      </div>

      {/* Original section 5, now section 6 */}
      <div className="faq-item">
        <p className="faq-question">6. Changes to Terms</p>
        <p className="faq-answer">
          ExpenseBot reserves the right to modify these terms at any time. Your
          continued use of the Service after changes constitutes acceptance of
          the new terms.
        </p>
      </div>

      {/* Original section 6, now section 7 */}
      <div className="faq-item">
        <p className="faq-question">7. Limitation of Liability</p>
        <p className="faq-answer">
          To the maximum extent permitted by law, ExpenseBot shall not be liable
          for any indirect or consequential damages arising from your use of the
          Service.
        </p>
      </div>

      {/* Original section 7, now section 8 */}
      <div className="faq-item">
        <p className="faq-question">8. Contact Information</p>
        <p className="faq-answer">
          If you have any questions about these Terms, please contact us at
          info@expensebot.ai.
        </p>
      </div>

      {/* Adding an effective date as section 9 */}
      <div className="faq-item">
        <p className="faq-question">9. Effective Date</p>
        <p className="faq-answer">
          These Terms of Service are effective as of May 12, 2025.
        </p>
      </div>
    </div>
  );
};

export default TERMSPage;
